import { createSelector } from 'reselect'

export const getRegistrationFormulaDetails = createSelector(state => state && state.ads.detail &&
state.ads.detail.registrationFormulaDetails ? state.ads.detail.registrationFormulaDetails : null,
registrationFormulaDetails => registrationFormulaDetails
)
